<template>
    <div class="card dashboard-card h-100">
        <div class="card-body">
            <span class="eyebrow">Retail attribution</span>
            <h4 class="card-title">Source breakdown</h4>

            <div v-if="chartData.length > 1">
                <GChart
                    :settings="{ packages: ['corechart'] }"
                    type="PieChart"
                    :data="chartData"
                    :options="chartOptions"
                    :resizeDebounce="500"
                ></GChart>
            </div>
            <div v-else class="empty-state">
                No source data available yet.
            </div>
        </div>
    </div>
</template>
<script>
import { GChart } from "vue-google-charts";

export default {
    name: "SummarySourcesCard",
    components: {
        GChart,
    },
    props: {
        sources: {
            type: Array,
            required: true,
        },
    },
    computed: {
        chartData() {
            return [["Source", "Leads"]].concat(this.sources);
        },
        chartOptions() {
            return {
                pieHole: 0.45,
                height: 280,
                backgroundColor: "transparent",
                chartArea: { left: 10, top: 10, width: "95%", height: 300 },
                legend: { position: "right", textStyle: { color: "#4c5968", fontSize: 14 } },
                colors: ["#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#6b7280"],
            };
        },
    },
};
</script>
<style scoped>
.dashboard-card {
    border: 1px solid #dbe4ea;
    border-radius: 16px;
    box-shadow: 0 12px 30px rgba(31, 60, 90, 0.08);
    min-height: 450px;
    margin-bottom: 20px;
}
.dashboard-card .card-body {
    background-color: #ffffff;
}
.eyebrow {
    display: block;
    color: #6f7d8a;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.card-title {
    margin: 4px 0 16px;
    color: #24313f;
    font-size: 24px;
    font-weight: 700;
}

.empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 220px;
    border: 1px dashed #d4dde5;
    border-radius: 12px;
    color: #71808f;
    font-size: 14px;
}
</style>